import { Role } from "../../types";
import {
  AnalyticsLastNMonthsRange,
  AnalyticsPeriodFilter,
} from "./types";

export const BUSINESS_ANALYTICS_ROLES: { [key: string]: boolean } = {
  [Role.ROOT]: true,
  [Role.FINANCE]: true,
  [Role.CUSTOMERSERVICE]: true,
  [Role.SYSTEM_ADMINISTRATOR]: true,
};

export interface PeriodOption {
  label: string;
  value: AnalyticsPeriodFilter;
  totalLabelSuffix: string;
}

export const PERIOD_OPTIONS: PeriodOption[] = [
  { label: "All time", value: null, totalLabelSuffix: "All time" },
  {
    label: "Last 3 months",
    value: AnalyticsLastNMonthsRange.LAST_3_MONTHS,
    totalLabelSuffix: "Last 3 months",
  },
  {
    label: "Last 6 months",
    value: AnalyticsLastNMonthsRange.LAST_6_MONTHS,
    totalLabelSuffix: "Last 6 months",
  },
  {
    label: "Last 12 months",
    value: AnalyticsLastNMonthsRange.LAST_12_MONTHS,
    totalLabelSuffix: "Last 12 months",
  },
];
